export { default } from './Renegociacao25EmpVantagens';
